<label
	[for]="option().inputId"
	[ngClass]="{
		'cursor-pointer': !isDisabled(),
		'control-selection-card-selected': isSelected(),
		'cursor-not-allowed opacity-50': isDisabled(),
		'px-7 py-6': hasCardsAsMarkdown(),
	}"
	(keydown.enter)="changedValue(option().inputId)"
	class="control-selection-card"
	data-test-class="selection-card-option"
	tabindex="0"
>
	@if (option().icon) {
		<svg-icon [src]="option().icon!" class="icon-container" />
	}
	<div
		[ngClass]="{
			'gap-1': option().byline,
		}"
		class="flex flex-1 flex-col"
	>
		<div
			[ngClass]="{
				'font-semibold': option().byline,
			}"
			class="leading-4"
		>
			{{ option().label | translate }}
		</div>

		@if (hasCardsAsMarkdown()) {
			<markdown [data]="option().byline" class="leading-6" />
		} @else if (option().byline) {
			<div class="leading-5">{{ option().byline | translate }}</div>
		}
	</div>
	<input
		[attr.aria-describedby]="option().inputId"
		[attr.aria-labelledby]="option().inputId"
		[attr.data-test-id]="option().inputId"
		[checked]="isSelected()"
		[disabled]="isDisabled()"
		[id]="option().inputId"
		[name]="name()"
		[ngClass]="{
			'!shadow-error-100': hasError() && !isDisabled() && !isReadonly(),
			'control-radio shadow-border shadow-ui-100':
				controlType() === 'radio',
			'control-checkbox': controlType() === 'checkbox',
		}"
		[type]="controlType()"
		(change)="changedValue(option().inputId)"
		class="flex-none shrink-0"
	/>
</label>
